import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, LinearProgress, SelectChangeEvent, Theme, Typography, useTheme } from '@mui/material';
import { MFTextField } from '../../lib/formik';
import { Formik, FormikProps } from "../../lib/formik/Formik";
import { useDispatch, useSelector } from 'react-redux';
import { getLocationList } from '../../redux-store/actions';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { getApplicationDetails, updateApplication } from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, MPOWER_ACCOUNT_TYPE_MASTER, ROLE_TYPE, USER_ROLES } from '../../utils/constant';
import { ProceedSaveLater } from './components';
import {
  applicationComparison,
  applyRoleBasedStatus,
  isModuleAllowed,
  saveForLater,
} from '../../utils/utilityFunctions';
import { GetTaggedIaListResponseBody, GetTaggedRmListResponseBody, IaListObject, MfuKycModificationResponseBody, RMType, SupportRmProp, TaggedRmObject } from '../../redux-store/types/api-types';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { distributorsValidationSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { LocationType, mdmsLocationList } from '../../redux-store/types/mdms';
import { showError } from '../../redux-store/actions/auth';
import { getRMById, getTaggedIaList, getTaggedRmList } from '../../redux-store/actions/userManagement';
import { CountryCodesDropDown } from '../commonComponents';
import MFCheckbox from '../../lib/formik/Checkbox';
import { useSnackbar } from 'notistack';
import { MfuKycModification } from '../../redux-store/actions/onBoarding';
import KycInfoPopup from '../onboarding/KycInfoPopup';

interface TaggedIA extends IaListObject {
  key: string;
  value: string | number
}

interface TaggedRM extends TaggedRmObject {
  key: string;
  value: string | number
}

type DistributorDetailsProps = {
  firstName: string;
  phone: any;
  email: string;
  saveType: string;
  rm_id: number | null | undefined;
  location: string | null;
  isBSEEnabled?: boolean;
  isEsignEnabled?: boolean;
  currentRM: TaggedRM | null;
  taggedIaId: TaggedIA | null;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} lg={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({
  isSupportRM,
  rmsList,
  values,
  locationMaster,
}: {
  isSupportRM: boolean;
  rmsList: any;
  values: any;
  locationMaster: mdmsLocationList[];
}) => {
  const [mobileElementWidth, setMobileElementWidth] = useState(null);

  useEffect(() => {
    const mobileElement = document.getElementsByName('phone');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  const rmsListSorting = [...rmsList].sort((a, b) => (a.name > b.name ? 1 : -1));
  const selectedRm = rmsList.find((item: SupportRmProp) => item.id === values.rm_id);

  return (
    <>
      <GridItem>
        <MFTextField
          name="firstName"
          label={isSupportRM ? "Service IA's Name" : "IA's Name"}
          placeholder="Enter IA name"
          disabled={true}
          value={values.firstName ?? ""}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label={isSupportRM ? "Service IA's Email Address" : "IA's Email Address"}
          placeholder="Enter IA Email ID"
          disabled={true}
          value={values.email ?? ""}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="phone"
          label={isSupportRM ? "Service IA's Mobile Number" : "IA's Mobile Number"}
          placeholder="Enter Mobile Number"
          disabled={true}
          value={values?.phone?.split(" ")?.[1] ?? ""}
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name="phone"
              value={values?.phone?.split(" ")?.[0] ?? ""}
              disabled={true}
            />
          }
        />
      </GridItem>
      <GridItem>
        {/* <MFSelectField
          name={`location`}
          label={'Location'}
          items={locationMaster.map((location) => ({
            key: location.value,
            value: location.key,
          }))}
          disabled
          value={values.location ?? ""}
        /> */}
        <MFTextField
          name={`location`}
          label={'Location'}
          placeholder="Enter Location"
          disabled
          value={values.location ?? ""}
        />
      </GridItem>
      {!rmsList.length && isSupportRM && (
        <GridItem>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '100%',
              width: '100%',
              mt: 10,
            }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 500,
                color: 'rgb(97, 209, 214)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '7%',
              }}>
              {`AMC's IA is Not Available`}
            </Typography>
          </Box>
        </GridItem>
      )}
      {isSupportRM && rmsList?.length > 0 && (
        <>
          <GridItem>
            <SearchableSelect
              name="rm_id"
              label="IA's Name*"
              items={rmsListSorting.sort().map((item: SupportRmProp) => ({
                key: item.name,
                value: item.id,
              }))}
              searchFieldPlaceholder={'Search IA'}
            />
          </GridItem>
          {values.rm_id && (
            <>
              <GridItem>
                <MFTextField
                  name="amcEmail"
                  label="IA's Email ID"
                  placeholder="Enter IA's Email ID"
                  value={selectedRm?.user?.email}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="amcMobile"
                  label="IA's Mobile Number"
                  placeholder="Enter IA's Mobile Number"
                  value={selectedRm?.user?.phone}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFSelectField
                  name={`amcLocation`}
                  label="Location"
                  items={locationMaster.map((location) => ({
                    key: location.value,
                    value: location.key,
                  }))}
                  value={selectedRm?.location}
                  disabled={true}
                />
              </GridItem>
            </>
          )}
        </>
      )}
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const { path: currentPath } = useRouteMatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role, userDetails } = useSelector((store: RootStateType) => store.auth);
  const { rm, rm_id, supportRm, support_rm_id } = application || {};
  const { auth } = useSelector((store: RootStateType) => store);
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [currentFlag, setCurrentFlag] = useState<string | null>(null);
  const [rmsDropdwn, setRmsDropdwn] = useState<Array<TaggedRM>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rmsLoading, setRmsLoading] = useState<boolean>(false);
  const [masterDataLoading, setMasterDataLoading] = useState<boolean>(false);
  const [taggedIaArray, setTaggedIaArray] = useState<Array<TaggedIA>>([])
  const [rmsList, setRmList] = useState<RMType[]>([]);
  const [locationMaster, setLocationMaster] = useState<mdmsLocationList[]>([]);
  const [taggedIaLoading, setTaggedIaLoading] = useState<boolean>(false)
  const [mandatoryKycPopupOpen, setMandatoryKycPopupOpen] = useState<boolean>(false)
  const [isKycModificationLoading, setKycModificationLoading] = useState<boolean>(false)
  const [kycModificationRes, setKycModificationRes] = useState<MfuKycModificationResponseBody | null>(null)
  const [kycLinkPopupOpen, setKycLinkPopupOpen] = useState<boolean>(false)
  const [isApplicationDeleteLoading, setApplicationDeleteLoading] = useState<boolean>(false)

  const { enqueueSnackbar } = useSnackbar();

  const formikRef = useRef<FormikProps<DistributorDetailsProps>>(null);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const isSupportRM = isDiyInvestorOnboarding ? false : auth.id === application?.supportRm?.userId;
  const { onboardingVia, accountType } = application || {};

  const {
    user: { email: RMEmail = '', firstName: RMFirstName = '', phone, countryCode },
    branchName: RMLocation = '',
  } = (isSupportRM ? supportRm : rm) || { empCode: '', user: { email: '' } };

  const isExecutionary = MPOWER_ACCOUNT_TYPE_MASTER[`${accountType ?? ""}`?.toUpperCase()] === MPOWER_ACCOUNT_TYPE_MASTER['EXY']; //for nexedge client

  const isHeldAway = MPOWER_ACCOUNT_TYPE_MASTER[`${accountType ?? ""}`?.toUpperCase()] === MPOWER_ACCOUNT_TYPE_MASTER['HLDAWY'];

  let isBSEEnabledInitialValue = application?.isBSEEnabled ?? true

  if (isExecutionary) {
    isBSEEnabledInitialValue = true
  }

  if (isHeldAway) {
    isBSEEnabledInitialValue = false
  }

  const getPhoneData = (countryCode: string, phone: string) => {
    return countryCode ? countryCode + ' ' + phone : phone
  }

  const initialValues: DistributorDetailsProps = useMemo(() => {
    const selectedTaggedRmObj = (rmsDropdwn ?? []).find(obj => `${obj?.value ?? ""}` === `${application?.taggedRmId ?? ""}`)

    const selectedTaggedIaObj = (taggedIaArray ?? []).find(obj => `${obj?.value ?? ""}` === `${application?.taggedIaId ?? ""}`)

    return {
      email: selectedTaggedIaObj ? (selectedTaggedIaObj?.email ?? "") : (RMEmail ?? ""),
      firstName: selectedTaggedIaObj ? (selectedTaggedIaObj?.name ?? "") : (RMFirstName ?? ""),
      phone: selectedTaggedIaObj ? getPhoneData(selectedTaggedIaObj?.countryCode ?? "", selectedTaggedIaObj?.phone ?? "") : getPhoneData(countryCode ?? "", phone ?? ""),
      saveType: 'save and proceed',
      rm_id,
      location: selectedTaggedIaObj ? (selectedTaggedIaObj?.branchName ?? "") : (RMLocation ?? ""),
      isBSEEnabled: isBSEEnabledInitialValue,
      isEsignEnabled: application?.isEsignEnabled ?? onboardingVia === 'digital',
      currentRM: selectedTaggedRmObj ?? null,
      taggedIaId: selectedTaggedIaObj ?? null
    }
  }, [
    application,
    rmsDropdwn,
    taggedIaArray
  ]);

  const fetchTaggedIaList = async (rmId: string) => {
    const response = await (dispatch(getTaggedIaList({ rmId })) as unknown as Promise<GetTaggedIaListResponseBody>)

    const modifiedResponse = (response?.iaList ?? []).map(obj => ({
      ...obj,
      key: obj?.name ?? '',
      value: obj?.id ?? ''
    }))

    setTaggedIaArray(modifiedResponse);
  }

  const fetchTaggedRmList = async () => {
    const response = await (dispatch(getTaggedRmList()) as unknown as Promise<GetTaggedRmListResponseBody>)

    const modifiedResponse = (response?.rmList ?? []).map(obj => ({
      ...obj,
      key: obj?.name ?? '',
      value: obj?.id ?? ''
    }))

    setRmsDropdwn(modifiedResponse);
  }

  useEffect(() => {
    (async function () {
      try {
        setMasterDataLoading(true);

        // Calling below function to fetch TaggedRM list for Select RM
        await fetchTaggedRmList();

        const locations = (await dispatch(getLocationList())) as unknown as LocationType;

        setLocationMaster(locations.rmLocationList);

      } catch (e: unknown) {
        console.error((e as Error).message);
      } finally {
        setMasterDataLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      try {
        setRmsLoading(true);

        // Calling below function to fetch Tagged IA list for Tagged IA only when we have taggedRm iwappRmId available
        if (application?.taggedRm?.iwappRmId ?? "") {
          await fetchTaggedIaList(application?.taggedRm?.iwappRmId ?? "")
        }

        let updateRMList: RMType[] = [];
        if (isSupportRM) {
          const listedRM = ((await dispatch(getRMById(Number(support_rm_id)))) as unknown as RMType)
            ?.amcRmDetails;
          updateRMList =
            application?.rm_id &&
              (!application.rm.isActive || !listedRM?.amcRmIds.includes(`${application?.rm_id}`))
              ? [...(listedRM?.amcRms || []), application?.rm]
              : listedRM?.amcRms || [];
        }
        setRmList(updateRMList);
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
      finally {
        setRmsLoading(false);
      }
    })();
  }, [application]);

  useEffect(() => {
    (async function () {
      try {
        const isRexOrIaRole = isModuleAllowed({
          value: userDetails?.userRole ?? "",
          compareArr: [ROLE_TYPE.REX, ROLE_TYPE.IA]
        });

        if (!isRexOrIaRole || !formikRef.current) return;

        const { setValues, values } = formikRef.current;

        if (
          !masterDataLoading &&
          rmsDropdwn.length > 0 &&
          !application?.taggedRmId &&
          !values.currentRM
        ) {
          const firstRm = rmsDropdwn[0];

          setValues({
            ...values,
            currentRM: firstRm,
            taggedIaId: null,
          });

          setTaggedIaLoading(true);
          await fetchTaggedIaList(firstRm?.iwappRmId ?? "");
          setTaggedIaLoading(false);
        }

        if (
          taggedIaArray.length > 0 &&
          !application?.taggedIaId &&
          !formikRef.current?.values?.taggedIaId
        ) {
          const latestValues = formikRef.current.values;
          const firstIa = taggedIaArray[0];

          formikRef.current.setValues({
            ...latestValues,
            taggedIaId: firstIa,
            firstName: firstIa?.name ?? "",
            email: firstIa?.email ?? "",
            phone: getPhoneData(firstIa?.countryCode ?? "", firstIa?.phone ?? ""),
            location: firstIa?.branchName ?? ""
          });
        }
      } catch (error) {
        console.log(error);
        setTaggedIaLoading(false);
      }
    })();
  }, [masterDataLoading, rmsDropdwn, taggedIaArray]);

  useEffect(() => {
    if (!rmsLoading && !masterDataLoading && application && (application?.applicants ?? []).length) {

      const isDigitalOnboarding = `${application?.onboardingVia ?? ""}`.toLowerCase() === "digital"
      const primaryApplicant = application.applicants[0];

      if (
        isDigitalOnboarding &&
        !primaryApplicant?.isKraContactDetailsMatched
        // (
        //   !primaryApplicant.mobile ||
        //   !primaryApplicant.email ||
        //   !primaryApplicant.kraMobileNumber ||
        //   !primaryApplicant.kraEmailId ||
        //   primaryApplicant.mobile !== primaryApplicant.kraMobileNumber ||
        //   `${primaryApplicant?.email ?? ""}`.toLowerCase() !== `${primaryApplicant?.kraEmailId ?? ""}`.toLowerCase()
        // )
      ) {
        setMandatoryKycPopupOpen(true)
      }
    }
  }, [rmsLoading, masterDataLoading, application]);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      setIsLoading(true)

      if (!rmsList.length && isSupportRM) {
        throw `AMC's IA is Not Available`;
      }
      const { saveType } = values;
      const { id, applicant1ReferenceId, currentStep = null, status, hasPOA } = application || {};
      const checkApplication = applicationComparison(application, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        currentStep: currentStep === null ? 1 : currentStep,
        taggedRmId: values?.currentRM?.value ?? "",
        fundmanager_id: values?.currentRM?.value ?? "",
        isBSEEnabled: values.isBSEEnabled,
        isEsignEnabled: values.isEsignEnabled,
        taggedIaId: values?.taggedIaId?.value ?? ""
      });

      let currentStatus = status

      if (
        !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
        status === 'sent_to_amc_approver'
      ) {
        currentStatus = 'draft'
      } else if (
        !hasPOA &&
        AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
        status !== 'draft' &&
        applyRoleBasedStatus(role)
      ) {
        currentStatus = 'sent_to_amc_approver'
      }

      if (id && !checkApplication) {
        const response = await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              onboardingVia: values?.isEsignEnabled ? 'digital' : 'physical',
              status: currentStatus,
              currentStep: 1,
              taggedRmId: (values?.currentRM?.value ?? "") || (application?.taggedRmId ?? ""),
              isBSEEnabled: values.isBSEEnabled,
              isEsignEnabled: values.isEsignEnabled,
              taggedIaId: values?.taggedIaId?.value ?? null
            },
            applicationId: id,
          })
        );

        if (!response) return;

        saveType === 'save and proceed'
          ? history.push('personal-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      } else if (checkApplication) {
        saveType === 'save and proceed'
          ? history.push('personal-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      }
      saveType === 'save and proceed'
        ? history.push('personal-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
      console.error((e as Error).message);
    } finally {
      setIsLoading(false)
    }
  };

  const handleCheckboxCheck = (type: string, checked: boolean) => {
    setOpen(true)
    setCurrentFlag(type);
    if (type === 'bse') {
      setMessage(`Do you want to ${checked ? 'enable' : 'disable'} BSE?`)
    }
    else {
      setMessage(`Do you want to ${checked ? 'enable' : 'disable'} E-Sign?`)
    }
  }

  const handleDialogSave = (setValues: any, values: any) => {
    if (currentFlag === 'bse') {
      setValues({
        ...values,
        isBSEEnabled: !values.isBSEEnabled
      });
    } else if (currentFlag === 'esign') {
      setValues({
        ...values,
        isEsignEnabled: !values.isEsignEnabled
      });
    }
    setOpen(false);
  }

  const handleTaggedIaChange = ({ target: { value } }: SelectChangeEvent<unknown>) => {
    if (!formikRef.current) return

    const { setValues, values } = formikRef.current

    const selectedObj = (taggedIaArray ?? []).find(obj => `${obj?.value ?? ""}` === `${value ?? ""}`)

    setValues({
      ...values,
      taggedIaId: selectedObj ?? null,
      firstName: selectedObj?.name ?? "",
      email: selectedObj?.email ?? "",
      phone: getPhoneData(selectedObj?.countryCode ?? "", selectedObj?.phone ?? ""),
      location: selectedObj?.branchName ?? ""
    })
  }

  const handleSelectRmChange = async ({ target: { value } }: SelectChangeEvent<unknown>) => {
    try {
      if (!formikRef.current) return

      setTaggedIaLoading(true)

      const { setValues, values } = formikRef.current

      const selectedObj = (rmsDropdwn ?? []).find(obj => `${obj?.value ?? ""}` === `${value ?? ""}`)

      setValues({
        ...values,
        currentRM: selectedObj ?? null,
        taggedIaId: null,
      })

      await fetchTaggedIaList(selectedObj?.iwappRmId ?? "")

    } catch (e) {
      console.log("Error: ", e)
    } finally {
      setTaggedIaLoading(false)
    }
  }

  const handleKycModificationClick = async () => {
    try {
      if (application && (application?.applicants ?? []).length) {

        setKycModificationLoading(true)

        const primaryApplicant = application.applicants[0];

        const payload = {
          panNo: primaryApplicant?.panNo ?? "",
          emailId: primaryApplicant?.email ?? "",
          investorName: primaryApplicant?.name ?? "",
          isNameChange: "1",
          isEmailChange: "1",
          isMobileChange: "1",
          isAddressChange: "1",
          dob: primaryApplicant?.dateOfBirth ?? "",
          applicationId: Number(primaryApplicant?.applicationId ?? "") as number
        }

        const response = (await dispatch(MfuKycModification(payload)) as unknown as MfuKycModificationResponseBody);

        if (response) {
          setKycModificationRes(response)
          setMandatoryKycPopupOpen(false)
          setKycLinkPopupOpen(true)
        }
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setKycModificationLoading(false)
    }
  }

  const handleApplicationDeleteClick = async () => {
    try {
      if (application && application?.id) {

        setApplicationDeleteLoading(true)

        const response = (await dispatch(
          getApplicationDetails(application.id, 'delete')
        )) as unknown as { code: string; message: string };

        if (`${response?.code ?? ""}`.toLowerCase() === "success") {
          enqueueSnackbar('Application Deleted Successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });

          history.push("/onboarding/enter-pan-number")
        } else {
          enqueueSnackbar('Something wrong', {
            variant: 'error',
            autoHideDuration: 3000,
          });
        }
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setApplicationDeleteLoading(false)
    }
  }

  const handleCloseKycLinkPopup = () => {
    setKycLinkPopupOpen(false)

    history.push('/applications')
  }

  return (
    <>
      {(rmsLoading || masterDataLoading) && <LinearProgress />}
      {(!rmsLoading && !masterDataLoading) && (
        <>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={distributorsValidationSchema(isSupportRM, rmsList, userDetails?.userRole, role)}
            onSubmit={onSubmit}
            enableReinitialize={true}>
            {({ handleSubmit, values, setValues }) => {
              return (
                <>
                  <Box component="form" noValidate onSubmit={handleSubmit}>
                    <Grid container columnSpacing={3} rowSpacing={0.5}>
                      <Grid item xs={12} lg={6} >
                        <SearchableSelect
                          name={`currentRM`}
                          label="Select RM"
                          items={rmsDropdwn ?? []}
                          searchFieldPlaceholder={'Search RM'}
                          value={values?.currentRM?.value ?? ""}
                          onChange={handleSelectRmChange}
                          loading={taggedIaLoading}
                        />
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <SearchableSelect
                          name="taggedIaId"
                          label="Select Tagged IA"
                          items={taggedIaArray ?? []}
                          searchFieldPlaceholder={'Search IA'}
                          disabled={rmsLoading || !values.currentRM || taggedIaLoading}
                          value={values?.taggedIaId?.value ?? ""}
                          onChange={handleTaggedIaChange}
                        />
                      </Grid>

                      <RMDetail
                        isSupportRM={isSupportRM}
                        rmsList={rmsList}
                        values={values}
                        locationMaster={locationMaster}
                      />

                      <Grid item xs={12}>
                        <Divider sx={{ color: 'red', mt: 2 }} />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant='h2' mt={2} sx={{ color: theme.palette.text.primary }}>Enable/Disable BSE and E-Sign</Typography>
                      </Grid>

                      <Grid item container mt={3}>
                        <Grid item xs={12} sm={6} >
                          <MFCheckbox
                            name={`isBSEEnabled`}
                            label={`Is BSE Enabled`}
                            checked={values.isBSEEnabled}
                            sx={{ letterSpacing: '1px' }}
                            onChange={(e) => handleCheckboxCheck('bse', e.target.checked)}
                            disabled={[USER_ROLES.AMCAPPROVER].includes(role) || isExecutionary || isHeldAway}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <MFCheckbox
                            name={`isEsignEnabled`}
                            label={`Is E-Sign Enabled`}
                            checked={values.isEsignEnabled}
                            sx={{ letterSpacing: '1px' }}
                            onChange={(e) => handleCheckboxCheck('esign', e.target.checked)}
                            disabled={[USER_ROLES.AMCAPPROVER].includes(role) || isHeldAway}
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12} my={1} />
                      <ProceedSaveLater
                        saveLater={() => {
                          setValues({
                            ...values,
                            saveType: 'save for later',
                          });
                        }}
                        saveAndProceed={() => {
                          setValues({
                            ...values,
                            saveType: 'save and proceed',
                          });
                        }}
                        loader={isLoading}
                        clickedButton={values.saveType}
                        saveButtonText="Continue"
                        showEndIcon={false}
                      />
                    </Grid>
                  </Box>
                  <Dialog
                    onClose={setOpen}
                    open={open}
                    maxWidth='sm'
                    fullWidth
                    sx={{
                      '& .MuiPaper-root': {
                        borderRadius: '15px',
                        backgroundColor: "background.paper",
                        rowGap: "25px",
                      },
                    }}
                  >
                    <DialogContent sx={{ paddingTop: "25px" }}>
                      <Box sx={{ display: "flex", columnGap: "8px" }}>
                        <Typography variant='h2' color="text.primary" mb="10px">{message}</Typography>
                      </Box>
                    </DialogContent>
                    <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                      <Button
                        variant="outlined"
                        onClick={() => setOpen(false)}
                        sx={(theme: Theme) => ({
                          color: theme.palette.text.secondary,
                          flex: 1,
                          border: `0.5px solid ${theme.palette.text.secondary}`,
                          padding: "10px",
                          "&:hover, &.Mui-focusVisible": {
                            borderColor: theme.palette.text.secondary,
                            backgroundColor: theme.palette.background.default
                          }
                        })}
                      >
                        {'No'}
                      </Button>
                      <Button
                        variant="contained"
                        sx={(theme: Theme) => ({
                          flex: 1,
                          color: theme.palette.textDark.primary,
                          padding: "10px"
                        })}
                        onClick={() => handleDialogSave(setValues, values)}
                      >
                        {'Yes'}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )
            }
            }
          </Formik>
          <KycInfoPopup
            open={mandatoryKycPopupOpen}
            title="The data does not match the KYC records. Do you want to proceed with KYC modification?"
            subtitle={`KRA Mobile: ${application?.applicants?.[0]?.kraMobileNumber ?? "-"}\nKRA Email: ${application?.applicants?.[0]?.kraEmailId ?? "-"}`}
            submitButtonLabel="Yes"
            onSubmitBtnClick={handleKycModificationClick}
            showCloseButton
            closeButtonLabel="Delete the application"
            onCloseBtnClick={handleApplicationDeleteClick}
            // titleSpacing={6}
            isSubmitBtnLoading={isKycModificationLoading}
            isCloseBtnLoading={isApplicationDeleteLoading}
          />
          <KycInfoPopup
            open={kycLinkPopupOpen}
            title={kycModificationRes?.message ?? ""}
            subtitle={kycModificationRes?.kycOnboardingURL ?? ""}
            copyText={kycModificationRes?.kycOnboardingURL ?? ""}
            submitButtonLabel="Okay"
            onSubmitBtnClick={handleCloseKycLinkPopup}
          />
        </>
      )}
    </>
  );
}
